<script lang="ts">
	import { slide } from 'svelte/transition'
	import Render from '#components/render.svelte'

	let { title, body, active = false, size = undefined } = $props()

	function toggle_text(str: string, toggle: boolean): string {
		return str.replace(/\{\{([^|{}]+)\|([^|{}]+)\}\}/, (_, first, second) =>
			toggle ? second.trim() : first.trim()
		)
	}
</script>

<div class="item">
	<button class="title {size}" onclick={() => (active = !active)}>
		{toggle_text(title, active)}
		<svg class="arrow" class:active>
			<use xlink:href="/images/vector.svg#chevron-up"></use>
		</svg>
	</button>
	{#if active}
		<div class="body" transition:slide>
			<Render content={body} />
		</div>
	{/if}
</div>

<style lang="css">
	.item {
		color: var(--c-midground);
		padding-block-end: 2.5rem;

		&::after {
			background-color: var(--c-midground);
			content: '';
			display: block;
			inset: 100% 0 auto;
			opacity: 0.5;
			size: 1px 100%;
			position: absolute;
		}

		& + :global(.item) {
			padding-block: 2rem;
		}
	}

	.title {
		align-items: center;
		display: flex;
		font: 600 var(--f-h3);
		justify-content: space-between;
		letter-spacing: var(--ls-h3);
		text-align: start;
		width: 100%;

		&.small {
			font: 600 var(--f-h5);
			letter-spacing: var(--ls-h5);
		}

		&.medium {
			font: 600 var(--f-h4);
			letter-spacing: var(--ls-h4);
		}

		&.large {
			font: 600 var(--f-h3);
			letter-spacing: var(--ls-h3);
		}
	}

	.arrow {
		color: var(--c-midground);
		rotate: 180deg;
		size: 2.75rem;
		transition: rotate 0.25s ease;

		&.active {
			rotate: 0deg;
		}
	}

	.body {
		color: var(--c-midground);
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);
		padding-block: 1rem 0;

		:global {
			.link {
				color: var(--c-foreground);
				margin-block-start: 0.75rem;
			}
		}
	}
</style>
